/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    ShowReportAccountList({ commit }, data) {
        return axios.post(http + '/Report/show_reportrepair', data).then(res => {
            return res.data
        })
    },
    ShowComplaintProposalPraiseAccountList({ commit }, data) {
        return axios.post(http + '/Report/show_reportadvice', data).then(res => {
            return res.data
        })
    }
};

const AccountModule = {
    state,
    getters,
    actions,
    mutations
}
export default AccountModule
